import { useState, useEffect } from "react";
import { Button } from "./ui/button";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookies_accepted");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookies_accepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-2xl mx-auto bg-[#3D2B1F] text-cream rounded-lg shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm leading-relaxed flex-1">
          Diese Website verwendet Cookies, um dir die bestmögliche Erfahrung zu bieten. Mit der Nutzung der Website stimmst du der Verwendung von Cookies gemäss unserer{" "}
          <a href="/impressum" className="underline hover:text-white">Datenschutzerklärung</a> zu.
        </p>
        <Button
          onClick={accept}
          className="bg-[#A8B5A0] text-[#3D2B1F] hover:bg-[#8A9A7C] px-6 py-2 text-xs uppercase tracking-widest whitespace-nowrap shrink-0"
          data-testid="cookie-accept-btn"
        >
          Verstanden
        </Button>
      </div>
    </div>
  );
};
